import { render } from "./AddEditCategorySlideOver.vue?vue&type=template&id=388eb0b6"
import script from "./AddEditCategorySlideOver.vue?vue&type=script&lang=ts"
export * from "./AddEditCategorySlideOver.vue?vue&type=script&lang=ts"
script.render = render

export default script